function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.717 26c-.125 0-.25-.017-.374-.052a1.287 1.287 0 01-.947-1.23V16.77H3.321C2.59 16.77 2 16.195 2 15.487c0-.708.591-1.282 1.32-1.282h7.397c.73 0 1.32.574 1.32 1.282v4.89L21.23 6.586a1.341 1.341 0 011.484-.533c.561.16.946.66.946 1.229v6.923h.519a.5.5 0 01.5.5v1.564a.5.5 0 01-.5.5h-1.84c-.73 0-1.32-.574-1.32-1.282v-3.864l-9.193 13.791c-.249.372-.67.586-1.11.586zM22.199 21.002l3.79-3.793a.725.725 0 011.019 0l3.793 3.795c.263.263.266.68.005.946l-.264.27a.725.725 0 01-1.023.004l-2.136-2.14v6.232a.696.696 0 01-.708.684h-.352a.696.696 0 01-.708-.684v-6.23l-2.125 2.138a.725.725 0 01-1.02 0l-.273-.273A.668.668 0 0122.2 21z",
  fill: "currentColor"
})));